export default __webpack_public_path__ + "static/media/ksLogoWhite.4eaf243e.svg";